
<div class="address-search-container">
  <!-- Label -->
  <label v-if="label" for="address-search-input" class="font-weight-bold">
    {{ label }}
  </label>

  <!-- Input avec autocomplétion -->
  <b-form-group class="mb-0">
    <div class="input-with-icon">
      <b-form-input
        id="address-search-input"
        v-model="searchQuery"
        :maxlength="maxLength"
        :disabled="disabled || !isServiceEnabled"
        :state="searchInputState"
        aria-describedby="address-search-input-live-feedback"
        autocomplete="off"
        class="input-with-icons"
        @keydown="handleKeyDown"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown.down.prevent="navigateDown"
        @keydown.up.prevent="navigateUp"
        @keydown.enter.prevent="selectHighlighted"
        @keydown.esc="closeDropdown"
      />

      <!-- Icône de recherche à gauche -->
      <div class="search-icon-container-left">
        <b-spinner v-if="isSearching" small variant="primary"></b-spinner>
        <b-icon v-else icon="search" class="search-icon"></b-icon>
      </div>
      <!-- Icône de fermeture à droite (visible si du texte est saisi) -->
      <div
        v-show="searchQuery"
        class="clear-icon-container"
        @click="clearInput"
      >
        <svg-icon icon-name="icone-fermer-x" className="clear-icon" />
      </div>
    </div>

    <!-- Liste déroulante des résultats -->
    <div
      v-if="showDropdown && hasResults"
      ref="dropdown"
      class="search-results-dropdown"
      role="listbox"
    >
      <div
        v-for="(result, index) in displayedResults"
        :key="result.Id || index"
        :class="[
          'search-result-item',
          { 'search-result-item-highlighted': index === highlightedIndex },
          { 'search-result-item-container': result.Type === 'Container' },
        ]"
        role="option"
        :aria-selected="index === highlightedIndex"
        tabindex="-1"
        @click="selectResult(result)"
        @mouseenter="highlightedIndex = index"
        @focus="highlightedIndex = index"
      >
        <!-- Conteneur pour l'adresse -->
        <div class="address-content">
          <!-- Texte de l'adresse avec highlight -->
          <span
            class="address-text"
            v-html="highlightMatch(result.Text || result.Description)"
          ></span>

          <!-- Badge pour containers avec nombre d'éléments -->
          <b-badge
            v-if="result.Type === 'Container'"
            variant="default"
            class="container-badge"
          >
            {{ getContainerCountLabel(result) }}
          </b-badge>
        </div>

        <!-- Flèche pour les containers -->
        <b-icon
          v-if="result.Type === 'Container'"
          icon="chevron-right"
          class="ml-auto chevron-icon"
        ></b-icon>
      </div>
    </div>
    <ErreurValidation
      id="address-search-input-live-feedback"
      :message="searchErrorMessage"
      :force-show="!!searchErrorMessage"
    ></ErreurValidation>
  </b-form-group>
</div>
